document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-research-checkout]');
  if (!form) return;

  const status = form.querySelector('[data-research-status]');
  const confirmation = form.querySelector('[data-research-confirmation]');
  const checkout = form.querySelector('[data-checkout-button]');
  const message = form.querySelector('[data-research-message]');

  const validate = () => {
    const approved = Boolean(status.value && confirmation.checked);
    checkout.disabled = !approved;
    message.hidden = approved;
  };

  status.addEventListener('change', validate);
  confirmation.addEventListener('change', validate);
  form.addEventListener('submit', (event) => {
    validate();
    if (checkout.disabled) event.preventDefault();
  });
  validate();
});
